import type {
  TeaserBaseProps,
  TeaserMediaProps,
  TeaserTextProps,
  TeaserThemeProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Body, Content, Media, Title } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

interface TeaserOnSiteProps extends TeaserBaseProps, TeaserThemeProps, TeaserMediaProps, TeaserTextProps {}

/**
 * Also known as "På Plats-puffen".
 *
 * In the CMS title will be set to a location like "Kiev, Ukraina" or "USA" and text is usually set to some author names like "Jan Banan och Kalle Kula"
 *
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-onsite](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-onsite)
 * - Storybook: [TeaserOnSite](https://designsystem.dn.se/?path=/docs/section-teaseronsite--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-onsite/teaser-onsite.scss'`
 */
export const TeaserOnSite = ({
  areaType,
  targetLink,
  theme = 'nyheter',
  classNames,
  attributes,
  media,
  title,
  text,
}: TeaserOnSiteProps) => {
  const classes = formatClassString(['ds-teaser--onsite', classNames])

  return (
    <TeaserCard areaType={areaType} targetLink={targetLink} theme={theme} classNames={classes} attributes={attributes}>
      <Media media={media} rounded={true} />
      <Content>
        <Title title={`PÅ PLATS | ${title}`} />
        <Body text={text} />
      </Content>
    </TeaserCard>
  )
}
